import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalMessageService, GlobalMessageType, TranslatePipe } from '@spartacus/core';
import { Observable } from 'rxjs';
import { KnBrNacConfigurableComponent } from 'src/app/sales-libs/kn-br-nac/components/kn-br-nac-configurable/kn-br-nac-configurable.component';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { SloanCommonService } from 'src/app/services/sloan/sloan-common.service';
import { SloanNacTemplateModel } from '../../../models/sloan/sloan-nac-template-model';
import { SloanDownloadConfirmationDialogComponent } from '../sloan-download-confirmation-dialog/sloan-download-confirmation-dialog.component';
import { SloanUpdateTemplateDialogComponent } from '../sloan-update-template-dialog/sloan-update-template-dialog.component';
import { SloanUploadNewTemplateDialogComponent } from '../sloan-upload-new-template-dialog/sloan-upload-new-template-dialog.component';
import { SimpleFileUploadComponent, FilesAcceptDirective } from '@iplab/ngx-file-upload';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-sloan-nac-configurable',
    templateUrl: './sloan-nac-configurable.component.html',
    styleUrls: ['./sloan-nac-configurable.component.scss'],
    imports: [FormsModule, SimpleFileUploadComponent, FilesAcceptDirective, AsyncPipe, TranslatePipe]
})
export class SloanNacConfigurableComponent extends KnBrNacConfigurableComponent implements OnInit {
  nacTemplateList$: Observable<SloanNacTemplateModel[]> = this.sloanCommonService.loadNacTemplateList$();
  selectedTemplateData: SloanNacTemplateModel;
  selectedTemplateCode: string;
  triggerElement: HTMLElement;
  constructor(
    protected fb: FormBuilder,
    protected modalService: NgbModal,
    protected knBrCommonService: KnBrCommonService,
    protected globalMessageService: GlobalMessageService,
    protected sloanCommonService: SloanCommonService
  ) {
    super(fb, modalService, knBrCommonService, globalMessageService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.sloanCommonService.getNacTemplateList();
  }

  onTemplateSelection(templateData) {
    // set the selected template
    this.selectedTemplateData = templateData;
    this.selectedTemplateCode = templateData.code;
    this.downloadTypeProductAttributes = false;
    this.downloadTypeImages = false;
    this.downloadOtherProductAssets = false;
    this.downloadAllTheProducts = false;
    this.fileUploadControl.clear();
  }

  downloadProductAttributes() {
    this.sloanCommonService.downloadNacProductAttributes();
  }

  openUploadNewTemplateDialog() {
    this.triggerElement = document.activeElement as HTMLElement;
    this.uploadNewTemplateModalRef = this.modalService.open(SloanUploadNewTemplateDialogComponent);

    requestAnimationFrame(() => {
      const modalWindow = document.querySelector('ngb-modal-window') as HTMLElement;
      const modalBackdrop = document.querySelector('ngb-modal-backdrop') as HTMLElement;

      modalWindow?.classList.add('show');
      modalBackdrop?.classList.add('show');

      const textarea = modalWindow?.querySelector('textarea') as HTMLElement;
      textarea?.focus();
    });
  }

  deleteTemplate() {
    // Get the selected template name and pass it
    this.sloanCommonService.deleteNacTemplate(this.selectedTemplateData.templateName);
    this.knBrCommonService.getNacTemplateList();
  }

  openUpdateTemplateDialog() {
    this.triggerElement = document.activeElement as HTMLElement;

    // Get the selected template data and pass it
    let modalInstance: any;
    this.updateTemplateModalRef = this.modalService.open(SloanUpdateTemplateDialogComponent);
    modalInstance = this.updateTemplateModalRef.componentInstance;
    modalInstance.templateData = this.selectedTemplateData;

    requestAnimationFrame(() => {
      const modalWindow = document.querySelector('ngb-modal-window') as HTMLElement;
      const modalBackdrop = document.querySelector('ngb-modal-backdrop') as HTMLElement;

      modalWindow?.classList.add('show');
      modalBackdrop?.classList.add('show');

      const firstInput = modalWindow?.querySelector('input') as HTMLElement;
      firstInput?.focus();
    });

    // removing the selected template data once update is done.
    this.updateTemplateModalRef.result.then((res) => {
      this.selectedTemplateData = null;
      this.selectedTemplateCode = null;
    });
  }

  openDownloadConfirmationDialog() {
    const formData: FormData = new FormData();

    // Condition to send the file
    if (!this.downloadAllTheProducts) {
      formData.append('attachment', this.fileUploadControl.value[0]);
    }

    this.sloanCommonService
      .importOrDownloadNacTemplate(
        this.selectedTemplateData.templateName,
        this.downloadTypeProductAttributes,
        this.downloadTypeImages,
        this.downloadOtherProductAssets,
        formData
      )
      .subscribe(
        (response: any) => {
          // open on success.
          this.triggerElement = document.activeElement as HTMLElement;
          this.downloadConfirmationModalRef = this.modalService.open(SloanDownloadConfirmationDialogComponent);
          requestAnimationFrame(() => {
            const modalWindow = document.querySelector('ngb-modal-window') as HTMLElement;
            const modalBackdrop = document.querySelector('ngb-modal-backdrop') as HTMLElement;

            modalWindow?.classList.add('show');
            modalBackdrop?.classList.add('show');

            const textarea = modalWindow?.querySelector('textarea') as HTMLElement;
            textarea?.focus();
          });
        },
        (errorRes) => {
          // Write code to show the message from backend.
          const errors = (errorRes?.error?.errors || errorRes?.details || []) as Array<any>;
          if (errors.length > 0) {
            errors.forEach((error) => {
              const type = error.type.toLowerCase();
              if (type.indexOf('warning') !== -1) {
                this.globalMessageService.add({ raw: error.message }, GlobalMessageType.MSG_TYPE_WARNING);
              } else if (type.indexOf('error') !== -1) {
                this.globalMessageService.add({ raw: error.message }, GlobalMessageType.MSG_TYPE_ERROR);
              }
            });
          } else {
            if (this.downloadAllTheProducts) {
              this.globalMessageService.add({ key: 'nacMessages.importFailureMsg' }, GlobalMessageType.MSG_TYPE_ERROR);
            } else {
              this.globalMessageService.add(
                { key: 'nacMessages.downloadFailureMsg' },
                GlobalMessageType.MSG_TYPE_ERROR
              );
            }
          }
        }
      );
  }
}
